var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.38C2.13493 13.2675 3.66079 12.6444 5.25 12.6444C6.83921 12.6444 8.36507 13.2675 9.5 14.38C10.6349 15.4924 12.1608 16.1155 13.75 16.1155C15.3392 16.1155 16.8651 15.4924 18 14.38V3.45138C16.8651 4.56383 15.3392 5.18694 13.75 5.18694C12.1608 5.18694 10.6349 4.56383 9.5 3.45138C8.36507 2.33893 6.83921 1.71582 5.25 1.71582C3.66079 1.71582 2.13493 2.33893 1 3.45138V14.38ZM1 14.38V22.88",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu6);
export default __webpack_public_path__ + "static/media/iconMenu6.a7bfa3e244ef3b35c6c5bdaaa1c434f0.svg";
export { ForwardRef as ReactComponent };